var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "flex-1" }, [
    _c("div", { staticClass: "flex-1" }, [
      _c("div", { staticClass: "py-6" }, [
        _c("h3", { staticClass: "text-lg font-medium mb-3" }, [
          _vm._v("Step 3 of 9: Client Services"),
        ]),
        _c("div", { staticClass: "grid grid-cols-1 gap-1" }, [
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "ValidationProvider",
                { attrs: { name: "Required Services" } },
                [
                  _c(
                    "FormGroup",
                    {
                      scopedSlots: _vm._u([
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c("p", { staticClass: "mb-2" }, [
                                _vm._v(" Required Services "),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _c("FormMultiselect", {
                        attrs: {
                          name: "support_type",
                          placeholder: "Select",
                          options: _vm.supportTypeOptions,
                          inputClass: "w-full",
                          getParentCustom: "clientWidth",
                          multiple: true,
                        },
                        on: {
                          input: (val) => _vm.updateField("support_type", val),
                        },
                        model: {
                          value: _vm.formData.support_type,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "support_type", $$v)
                          },
                          expression: "formData.support_type",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _vm.isFrequencySelect
                ? _c(
                    "FormGroup",
                    {
                      attrs: { title: "" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "title",
                            fn: function () {
                              return [
                                _c("p", { staticClass: "mb-2" }, [
                                  _vm._v(" Frequency "),
                                  _c("span", { staticClass: "subText" }, [
                                    _vm._v("(optional)"),
                                  ]),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        false,
                        587399
                      ),
                    },
                    [
                      _c("FormSelect", {
                        attrs: {
                          name: "frequency",
                          placeholder: "Select Frequency",
                          getParentCustom: "clientWidth",
                          options: _vm.frequencyOptions,
                          inputClass: "w-full",
                        },
                        on: {
                          input: (val) => {
                            _vm.updateField("frequency", val)
                            _vm.updateFrequence(val)
                          },
                        },
                        model: {
                          value: _vm.formData.frequency,
                          callback: function ($$v) {
                            _vm.$set(_vm.formData, "frequency", $$v)
                          },
                          expression: "formData.frequency",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-span-2" },
            [
              _c(
                "FormGroup",
                {
                  scopedSlots: _vm._u([
                    {
                      key: "title",
                      fn: function () {
                        return [
                          _c("p", { staticClass: "mb-2" }, [
                            _vm._v(" General Notes "),
                            _c("span", { staticClass: "subText" }, [
                              _vm._v("(optional)"),
                            ]),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c("FormTextarea", {
                    attrs: {
                      customBorderClass: "borderTen",
                      name: "client_services_gen_notes",
                      placeholder: "Type here",
                      inputClass: "w-full",
                      rows: 3,
                    },
                    on: {
                      input: (val) =>
                        _vm.updateField("client_services_gen_notes", val),
                    },
                    model: {
                      value: _vm.localFormData.client_services_gen_notes,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.localFormData,
                          "client_services_gen_notes",
                          $$v
                        )
                      },
                      expression: "localFormData.client_services_gen_notes",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }